import SapFlowType from './SapFlowType';
import Category from './Category';
export interface SapFlowConfigItemNode {
  id: string;
  name: string;
  fileformat: string;
  group: boolean;
  type: 'SUPPLIED' | 'GENERATED';
}

export interface SapFlowConfigProcessNode {
  id: string;
  details: string;
  sapname: string;
  displayname: string;
  order: number;
  sap: {
    id: string;
    name: string;
  };
  toolblock: {
    id: string;
    name: string;
  };
  params: { key: string; value: string }[];
}

export enum SapFlowConfigParamType {
  String = 'String',
  Int = 'Int',
  Float = 'Float',
  Enum = 'Enum',
  Flag = 'Flag',
  Boolean = 'Boolean',
  ListString = 'ListString',
  ListInt = 'ListInt',
  ListFloat = 'ListFloat',
  ListEnum = 'ListEnum',
}

export interface SapFlowConfigParamDetails {
  processNodeId: string;
  processNodeOrder: number;
  params: SapFlowProcessNodeParamDetails[];
}

export interface SapFlowProcessNodeParamDetails {
  id: string;
  name: string;
  displayname: string;
  description: string;
  toolbox: string;
  toolblock: string;
  sap: string;
  type: SapFlowConfigParamType;
  default_value: any;
  possible_values: string[];
  version: number;
}

export interface SapFlowConfig {
  id: string;
  name: string;
  description: string;
  isCustom: boolean;
  itemnodeconfigs: SapFlowConfigItemNode[];
  processnodeconfigs: SapFlowConfigProcessNode[];
  categories: Category[];
  types: SapFlowType[];
}

export interface SapFlowTansactionParamsUpdateDTO {
  sapflowid: string;
  processnodeparams: {}[];
}
